import { getItem, persistQS } from '@/actions/pdp.actions';
import { Button } from '@components/tailwind';
import { colorAttributeCompare, defaultAttributeCompare } from "@features/pdp/attribute-sorting";
import DesignGridWrapper from '@features/pdp/components/DesignGridWrapper';
import { Breakpoints } from '@settings';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { useMediaQuery } from 'react-responsive';
import { Views } from '..';
import ColorSwatches from '../../../../components/ColorSwatches';
import Swatches from '../../components/ProductSwatches/Swatches';
import { MIYO_DISABLED_COLORS } from '../../settings';

const UpdateVariant = ({ setView }) => {
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.MD });
  const dispatch = useAppDispatch();
  const { variants, site, details } = useSelector((state: any) => state.pdpItem);
  const [baseUrl, setBaseUrl] = React.useState('');
  const [updatedUrl, setUpdatedUrl] = React.useState('');
  const isRtic = site?.id === 2;

  useEffect(() => {
    setBaseUrl(window.location.href);
  }, []);

  const colors =
    variants?.colors
      ?.filter((color) => !MIYO_DISABLED_COLORS.includes(color.id) && color.isInStock && color.isAvailable)
      .toSorted(colorAttributeCompare) ?? [];

  const changeItemHandler = (swatchData) => () => {
    dispatch(getItem(`${swatchData.url}&design=true`, { skipUrlUpdate: true }));
    const url = persistQS(`${swatchData.url}&design=true`);
    setUpdatedUrl(url);
  };

  const onActionClick = (action: 'cancel' | 'update') => (e) => {
    e.preventDefault();

    setUpdatedUrl('');
    if (action === 'cancel') {
      setUpdatedUrl('');
      dispatch(getItem(baseUrl, { skipUrlUpdate: true }));
      setView(Views.DESIGN);
      return;
    }

    if (action === 'update') {
      dispatch(getItem(updatedUrl));
      setView(Views.DESIGN);
      return;
    }
  };

  if (!variants) return null;

  return (
    <div className=''>
      <DesignGridWrapper maxHeight='calc(100dvh - 500px)'>
        <div className='tw-px-3'>
          {!!variants?.activeSize && (
            <Swatches
              label='Size'
              attributes={variants?.sizes
                ?.filter(
                  (s) =>
                    (s.isAvailable && s.isInStock) ||
                    (variants?.activeSize && s.id === variants?.activeSize?.id)
                )
                .toSorted(defaultAttributeCompare)}
              activeAttribute={variants?.activeSize}
              itemHandler={changeItemHandler}
              wrapperClassName='tw-w-full tw-mt-1 tw-mb-6'
              indicateSale={isRtic && variants?.flagSizeSales}
              swatchSize='sm'
            />
          )}

          <ColorSwatches
            colors={colors}
            activeColor={variants?.activeColor}
            itemHandler={changeItemHandler}
            wrapperClassName='tw-w-full tw-mt-1 tw-mb-6'
            indicateSale={isRtic && variants?.flagColorSales}
            swatchSize='sm'
          />
        </div>
      </DesignGridWrapper>

      <div className='tw-mt-5'>
        {details && (
          <p className='tw-mb-2 tw-text-center tw-text-xs tw-font-semibold'>{details?.displayName}</p>
        )}
        <div className='t-justify-between tw-flex tw-items-center tw-gap-3'>
          <div className='tw-w-3/4 sm:tw-w-4/5'>
            <Button
              variant='primary'
              size={isMobile ? 'sm' : 'base'}
              onClick={onActionClick('update')}
              fullWidth='all'>
              Update
            </Button>
          </div>
          <div className='tw-w-1/4 sm:tw-w-1/5'>
            <Button variant='link' onClick={onActionClick('cancel')} size={isMobile ? 'sm' : 'base'}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateVariant;
